declare global {
  interface Window {
    _fb_loaded?: boolean;
  }
}

import { Cookies } from 'react-cookie';

import { areCookiesAvailable } from 'wanderu-utils';

const THIRTY_SECONDS_IN_MS = 30 * 1000;
const ONE_SECOND_IN_MS = 1 * 1000;
const FACEBOOK_PIXEL_COOKIE_NAME = '_fbp';
const FACEBOOK_CLICK_COOKIE_NAME = '_fbc';

export const getFacebookPixelCookies = async () => {
    return new Promise<{ fbc: string; fbp: string } | undefined>(resolve => {
        if (!areCookiesAvailable()) {
            resolve(undefined);
            return;
        }

        const cookies = new Cookies();
        const startTime = Date.now();
        const intervalId = setInterval(() => {
            // eslint-disable-next-line no-underscore-dangle
            const sdkHasLoaded = !!window._fb_loaded;

            if (sdkHasLoaded) {
                clearInterval(intervalId);
                // Once the SDK has loaded, give it a bit of time to set/update the cookies
                setTimeout(() => resolve({
                    fbc: cookies.get(FACEBOOK_CLICK_COOKIE_NAME),
                    fbp: cookies.get(FACEBOOK_PIXEL_COOKIE_NAME),
                }), 100);
                return;
            }

            if (Date.now() > startTime + THIRTY_SECONDS_IN_MS) {
                clearInterval(intervalId);
                resolve(undefined);
            }
        }, ONE_SECOND_IN_MS);
    });
};
